export function slugifySeoValue(value?: string | null): string {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9\s-]/g, ' ')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function slugToSearchTerm(slug?: string | null): string {
  if (!slug) {
    return '';
  }

  return decodeURIComponent(slug)
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getListingSeoSlug(listing: any): string {
  const title = listing?.title || listing?.nickname || listing?.name || '';
  const city = listing?.address?.city || '';
  return slugifySeoValue([title, city].filter(Boolean).join(' '));
}

export function getEventSeoSlug(event: any): string {
  const name = event?.name || '';
  const city = event?._embedded?.venues?.[0]?.city?.name || '';
  const date = event?.dates?.start?.localDate || '';
  return slugifySeoValue([name, city, date].filter(Boolean).join(' '));
}

export function getTrackSeoSlug(track: any): string {
  const name = track?.name || '';
  const artist = track?.artists?.[0]?.name || '';
  return slugifySeoValue([name, artist].filter(Boolean).join(' '));
}
